import React, { useState } from 'react';
import { PermissionTypesEnum } from '@mock/Permissions.ts';
import { useTranslation } from 'react-i18next';

interface ComponentProps {
  permission: PermissionTypesEnum[];
}

const PermissionError: React.FC<ComponentProps> = ({ permission }) => {
  const { t } = useTranslation(['admin', 'client']);
  const [showDetail, setShowDetail] = useState(false);

  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-800 mb-2">{t('client:common.permissionError.title')}</h1>
        <p className="text-gray-600">{t('client:common.permissionError.message')}</p>
        {permission.length > 0 && (
          <div className="mt-4">
            <button
              onClick={() => setShowDetail(prev => !prev)}
              className="text-sm text-gray-400 hover:text-gray-600 cursor-pointer"
            >
              {showDetail ? '▼' : '▶'} {t('client:common.permissionError.detail')}
            </button>
            {showDetail && (
              <div className="mt-2 text-sm text-gray-400">
                {permission.join(', ')}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PermissionError;
